import type {
  PriceTierDiscountItemType,
  PriceTierDiscountType,
} from "../../priceTierDiscountCommons/index.js";
import { formatCurrency } from "../formatCurrency/index.js";
import { formatDiscountAmount } from "../formatDiscountAmount/index.js";
import { getItemName } from "../getItemName/index.js";

const getMinimumBasketValueDiscountDescription = ({
  discount,
  currency,
}: {
  discount: {
    itemType: PriceTierDiscountItemType | null;
    amount: number;
    type: PriceTierDiscountType;
    minimumBasketValue: number;
  };
  currency?: string;
}) => {
  const minBasketCurrencyValueFormatted = `${formatCurrency(discount.minimumBasketValue, currency)}`;

  const formattedDiscountAmount = formatDiscountAmount(discount, currency);

  const multipleItemTypeName = getItemName({
    itemType: discount.itemType,
    quantity: 2,
    extended: true,
  });

  return `Spend ${minBasketCurrencyValueFormatted} on ${multipleItemTypeName === "items" ? "any " : ""}${multipleItemTypeName}, get ${formattedDiscountAmount} off${
    discount.type === "perpetual-flat" ? " per item" : ""
  }`;
};

const getMinimumOrderQuantityDiscountDescription = ({
  discount,
  currency,
}: {
  discount: {
    quantity: number;
    itemType: PriceTierDiscountItemType | null;
    amount: number;
    type: PriceTierDiscountType;
  };
  currency?: string;
}) => {
  const formattedDiscountAmount = formatDiscountAmount(discount, currency);

  const multipleItemTypeName = getItemName({
    itemType: discount.itemType,
    quantity: 2,
    extended: true,
  });

  return `Buy ${multipleItemTypeName === "items" ? "any " : ""}${discount.quantity} ${multipleItemTypeName}, get ${formattedDiscountAmount} off${
    discount.type === "perpetual-flat" ? " per item" : ""
  }`;
};

export const getDiscountDescription = ({
  discount,
  currency,
}: {
  discount: {
    quantity: number;
    itemType: PriceTierDiscountItemType | null;
    amount: number;
    type: PriceTierDiscountType;
    minimumBasketValue: number;
  };
  currency?: string;
}) => {
  if (discount.minimumBasketValue > 0) {
    return getMinimumBasketValueDiscountDescription({
      discount,
      currency,
    });
  }

  return getMinimumOrderQuantityDiscountDescription({
    discount,
    currency,
  });
};
